<script lang="ts">
	import type { HTMLAttributes } from "svelte/elements";
	import Formatted from "./common/Formatted.svelte";

	const { order, children, label, ...rest }: { order: number; label: string } & HTMLAttributes<HTMLDivElement> =
		$props();
	const id = $props.id();
</script>

<div role="radiogroup" aria-labelledby={id} {...rest} class={["flex flex-col gap-3 sm:mb-3", rest.class]}>
	<h3 {id} class="flex gap-3.5 items-center">
		<div aria-hidden="true" class="select-none text-[.9375rem]/none tracking-[-0.15px] text-fcrbrown font-medium">
			<Formatted text={order.toString().padStart(2, "0")} />
		</div>
		<span class="text-[1.0625rem]/none">
			<Formatted text={label} />
		</span>
	</h3>
	{@render children?.()}
</div>
